const truthyValues = [
    "true",
    "1",
    "available",
    "in_stock",
    "instock",
    "active",
    "on",
];

const falsyValues = [
    "false",
    "0",
    "unavailable",
    "out_of_stock",
    "inactive",
    "off",
    "sold_out",
    "soldout",
];

const parseBooleanLike = (value: any): boolean | undefined => {
    if (typeof value === "boolean") {
        return value;
    }

    if (typeof value === "number") {
        if (Number.isNaN(value)) {
            return undefined;
        }
        return value !== 0;
    }

    if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (normalized.length === 0) {
            return undefined;
        }

        if (truthyValues.includes(normalized)) {
            return true;
        }

        if (falsyValues.includes(normalized)) {
            return false;
        }
    }

    return undefined;
};

export const isMenuAvailable = (menu: any): boolean => {
    if (!menu || typeof menu !== "object") {
        return true;
    }

    const candidates = [
        (menu as any).available,
        (menu as any).isAvailable,
        (menu as any).availability,
        (menu as any).status,
        (menu as any).inStock,
        (menu as any).in_stock,
    ];

    for (const candidate of candidates) {
        const parsed = parseBooleanLike(candidate);
        if (parsed !== undefined) {
            return parsed;
        }
    }

    return true;
};

const normalizeMenuOptions = (menu: any) => {
    if (!menu || typeof menu !== "object") {
        return menu;
    }

    const normalized: any = {
        ...menu,
    };

    const rawOptions = Array.isArray((menu as any).options)
        ? (menu as any).options
        : Array.isArray((menu as any).menu_options)
          ? (menu as any).menu_options
          : [];

    if (rawOptions.length === 0) {
        return normalized;
    }

    normalized.options = rawOptions.map((option: any) => {
        if (!option || typeof option !== "object") {
            return option;
        }

        const optionValues = Array.isArray(option.values) ? option.values : [];

        return {
            ...option,
            type: option.type ?? option.selection_type ?? option.selectionType,
            values: optionValues.map((value: any) => {
                if (!value || typeof value !== "object") {
                    return value;
                }

                return {
                    ...value,
                    name: value.name ?? value.label,
                    price: value.price ?? value.price_modifier,
                    is_available: value.is_available ?? value.isAvailable,
                };
            }),
        };
    });

    return normalized;
};

const normalizeMenuItem = (menu: any) => {
    if (!menu || typeof menu !== "object") {
        return menu;
    }

    const available = isMenuAvailable(menu);
    return {
        ...normalizeMenuOptions(menu),
        available,
    };
};

const normalizeMenus = (menus: any) => {
    if (!Array.isArray(menus)) {
        return menus;
    }

    return menus.map((menu) => normalizeMenuItem(menu));
};

export const normalizeShopMenuResponse = (data: any) => {
    if (!data || typeof data !== "object") {
        return data;
    }

    const normalized: any = {
        ...data,
    };

    if (Array.isArray(normalized.categories)) {
        normalized.categories = normalized.categories.map((category: any) => {
            if (!category || typeof category !== "object") {
                return category;
            }

            const normalizedCategory: any = {
                ...category,
            };

            normalizedCategory.menus = normalizeMenus((category as any).menus);

            return normalizedCategory;
        });
    }

    if (Array.isArray(normalized.menus)) {
        normalized.menus = normalizeMenus(normalized.menus);
    }

    return normalized;
};

export const normalizeMenuDetail = (menu: any) => normalizeMenuItem(menu);

export default isMenuAvailable;
